var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNafathLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 581.1 318.6"
    },
    xmlSpace: "preserve",
    viewBox: "22.5 44.5 535.6 230.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0A9A8F;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M426.1,233.8c1.5,0.2,2.4,0.4,3.3,0.4c21.3,0,42.7,0.1,64-0.1c12.7-0.1,20-6.8,20.4-19.4    c0.6-21,0.6-42,0.6-63c0-3.9,1.1-6.1,4.7-7.9c10.9-5.4,21.5-11.2,32.3-16.8c1.3-0.7,2.7-1.3,4.5-2.1c0.1,1.4,0.3,2.4,0.3,3.5    c0,29.1,0.5,58.2-0.2,87.3c-0.5,21.8-9.4,39.7-29.1,51c-10.1,5.8-21.3,7.9-32.7,7.9c-32.1,0.2-64.1,0.2-96.2,0    c-8.2-0.1-16.4-1.8-24.6-2.1c-5.5-0.2-11,1.1-16.6,1.4c-9.3,0.4-18.7,0.7-28,0.8c-26.3,0.1-52.6,0.3-78.9-0.1    c-7.8-0.1-15.9-1.2-23.4-3.4c-22.7-7-34.9-23.3-38.8-46.2c-0.8-4.9-1-9.9-1-14.9c-0.1-42.5,0-85-0.1-127.5c0-3.6,0.9-5.6,4.2-7.2    c11-5.5,21.8-11.3,32.7-16.9c1.3-0.7,2.7-1.3,4.8-2.3c0,2.5,0,4.3,0,6.1c0,47.6,0,95.3,0,142.9c0,3.7,0.2,7.5,0.7,11.2    c1.5,11.1,7.6,17.5,18.7,17.7c22.6,0.4,45.1,0.1,67.7,0.1c0.4,0,0.9-0.3,1.9-0.6c-1-2-1.9-3.9-2.9-5.7c-16-27.8-11.5-65.2,7-87.2    c11-13.2,25.3-20.4,42.3-21.9c17.3-1.5,33.9,0.9,48.1,12.1c15.4,12.1,23.3,28.3,25.8,47.5c2.6,19.1-0.9,36.8-10.8,53.3    C426.7,232,426.6,232.6,426.1,233.8z M398.7,185.7c-0.8-3.2-1.5-9.2-3.9-14.4c-4.9-10.6-13.9-14.9-25.5-14.3    c-10.4,0.6-17.9,5.9-21.5,15.7c-7.4,19.7,1.5,44.7,19.4,55.5c3.2,1.9,5.8,2,8.9-0.1C390.3,218.7,398,205.6,398.7,185.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M78.7,155.1c6.8-11.7,13.6-23.2,20.5-35c13.5,8.1,25.5,17.4,35.1,29.4c18.1,22.4,24.3,48.2,21.3,76.5    c-0.7,6.9-2.2,13.9-4.6,20.4c-6,16.6-18.8,26.3-35.8,27.1c-30.6,1.4-61.2,0.8-91.9,1.1c-0.1,0-0.3-0.1-0.8-0.4    c0.4-1,0.7-2.2,1.2-3.2c5.7-11,11.6-22,17.2-33.1c1.4-2.7,3-3.7,6.1-3.7c15.4,0.2,30.8-0.4,46.2,0.2c18.1,0.7,21.6-10.1,21.2-23    c-0.7-23.6-12.1-40.9-31.6-53.4C81.7,157.1,80.4,156.2,78.7,155.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M536.2,44.5c13.4,0,21.9,8.4,21.9,21.7c0,14.4-7.4,22.1-21.5,22.3c-13.4,0.2-22-8.4-22.1-22.1    C514.5,53.1,522.9,44.5,536.2,44.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M121.1,66.4c0,14.8-7.3,22.3-21.5,22.1c-13.5-0.2-22-9-21.9-22.5c0.2-13.2,8.8-21.5,22.3-21.5    C113.2,44.6,121.1,52.8,121.1,66.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M393,71.1c-0.1,14.7-6.8,21.6-21.3,21.6c-13.9,0-21.9-8.1-21.9-22.1c0-13.7,8.3-21.6,22.4-21.5    C385.5,49.2,393,57.3,393,71.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNafathLogo);
export default __webpack_public_path__ + "static/media/Nafath_logo.d3170ef20e5425f8339f0d44a1074a94.svg";
export { ForwardRef as ReactComponent };